import React, { FC } from "react";
import { Wrapper, Styler } from "./styled";

type Props = {
    title: string;
    to: string;
    appearance?: "dark" | "mid";
};

export const ChalleningSituationHomeCard: FC<Props> = props => {
    return (
        <Styler theme={props.appearance ?? "dark"}>
            <Wrapper to={props.to}>{props.title}</Wrapper>
        </Styler>
    );
};
